import { Injectable } from '@angular/core';
import { DataBagService } from '../common/data-bag.service';
import { Data2Service } from '../common/data2.service';
import { InfoboxService } from '../common/infobox/infobox.service';

@Injectable({
	providedIn: 'root',
})
export class AccommodationDataService {
	constructor(
		private readonly erp: Data2Service,
		private readonly bag: DataBagService,
		private readonly infobox: InfoboxService,
	) {}

	quartering(from, to, callback) {
		const data = {
			cmd: 'quartering',
			from: from.id,
			to: to.id,
		};
		this.erp.command('/istour/istourAccommodations/', data, (result, error) => {
			if (error) {
				this.infobox.error(error.error.error);
				callback(false);
			}
			callback(true);
		});
	}
}
